import React, { useEffect, useMemo } from 'react'
import { useCurrent, useFetch } from '../hooks'
import { CardHeaderWithActions, MwButton } from '../components/ui';
import TicketsList from '../components/tickets/TicketsList';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getStatusAppearance, getStatusLabel, normalizeStatusValue, normalizeSupportSettings } from '../constants/ticket';

const TicketsManage = () => {
    const navigate = useNavigate()
    const params = useParams()
    const [searchParams] = useSearchParams();
    const {currentTenantId,currentCompanyId,currentBranchId,currentLangId,user} = useCurrent();
    const [t] = useTranslation('global')
    const tenantId = currentTenantId || user?.tenant_id;
    const companyId = currentCompanyId || user?.company_id;
    const branchId = currentBranchId || user?.branch_id;
    const ticketsUrl =
        tenantId && companyId && branchId
            ? `${process.env.REACT_APP_SUPPORT_API_BASE_URL}/tenant/${tenantId}/${companyId}/${branchId}`
            : null;
    const {data:resultTickets,loading:loadingTickets} = useFetch(ticketsUrl, Boolean(ticketsUrl));
    const { data: supportSettingsResult } = useFetch(`${process.env.REACT_APP_SUPPORT_API_BASE_URL}/settings`);
    const { data: statusesResult } = useFetch(`${process.env.REACT_APP_SUPPORT_API_BASE_URL}/statuses`);
    const supportSettingsBase = normalizeSupportSettings(supportSettingsResult);
    const supportSettings = {
        ...supportSettingsBase,
        statuses: normalizeSupportSettings({ data: { statuses: statusesResult?.data || [] } }).statuses
    };

    useEffect(() => {
        if(resultTickets){
            console.log(resultTickets)
        }
    },[resultTickets]);

    const activeStatusValue = useMemo(() => normalizeStatusValue(searchParams.get('status') || 'all'), [searchParams]);
    const activeStatusLabel = useMemo(() => {
        if (!activeStatusValue || activeStatusValue === 'all') return '';
        return getStatusLabel(supportSettings?.statuses, activeStatusValue, currentLangId);
    }, [activeStatusValue, currentLangId, supportSettings?.statuses]);
    const activeStatusAppearance = useMemo(() => {
        if (!activeStatusValue || activeStatusValue === 'all') return null;
        return getStatusAppearance(supportSettings?.statuses, activeStatusValue);
    }, [activeStatusValue, supportSettings?.statuses]);

    return (
    <div>
        <CardHeaderWithActions
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                    <span>{t('support.tickets.listTitle')}</span>
                    {activeStatusLabel ? (
                        <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            padding: '4px 10px',
                            borderRadius: 999,
                            fontSize: 11,
                            fontWeight: 800,
                            background: activeStatusAppearance?.bg || '#e2e8f0',
                            color: activeStatusAppearance?.color || '#475569'
                        }}>
                            <span style={{ width: 7, height: 7, borderRadius: '50%', background: activeStatusAppearance?.dot || activeStatusAppearance?.color || '#94a3b8' }} />
                            {activeStatusLabel}
                        </span>
                    ) : null}
                </div>
            }
        >
            <MwButton type='saveBtn' onClick={()=>navigate(`/${params.tenant}/tickets/add`)} >{t('support.menu.createTicket')}</MwButton>
        </CardHeaderWithActions>
        <TicketsList data={resultTickets} loading={loadingTickets} supportSettings={supportSettings}/>
    </div>
    )
}

export default TicketsManage
